'use client';
import React from 'react';
import { ComparisonProvider } from '@/contexts/ComparisonContext';
import StickyCompareBar from '@/components/StickyCompareBar';

export default function ComparisonLayoutWrapper({ children }: { children: React.ReactNode }) {
  return (
    <ComparisonProvider>
      {children}
      <StickyCompareBar />
    </ComparisonProvider>
  );
}
